// Las referencias de un post — ADR-2026-10-08-el-post-tiene-planificacion-y-referencias.
//
// Texto libre (un link, una cuenta, por qué sirve) y, debajo, los links que se encontraron
// como enlaces que se abren en otra pestaña. Escribir es más rápido que una lista de campos
// "URL + nota", y lo que se pega desde el teléfono suele venir con texto alrededor.

import { useMemo, type ReactNode } from 'react';
import { ExternalLink, Instagram, Link2 } from 'lucide-react';
import { linksDe } from './referencias';

export function CajaDeReferencias({
  valor,
  onCambiar,
  accion,
}: {
  valor: string;
  onCambiar: (v: string) => void;
  /** Lo que va abajo a la derecha, en el renglón de los links (el "Crear con IA"). */
  accion?: ReactNode;
}) {
  const links = useMemo(() => linksDe(valor), [valor]);

  return (
    <>
      <textarea
        value={valor}
        onChange={(e) => onCambiar(e.target.value)}
        rows={4}
        placeholder="Pegá links o cuentas que te inspiran (pinterest.com/…, @marca) y anotá qué tomar de cada una."
        className="w-full resize-y rounded-xl border border-neutral-200 py-2.5 px-3 text-sm leading-relaxed text-brand-black outline-none placeholder:text-neutral-400 focus:border-[#1644EB] focus:ring-4 focus:ring-[#EEF2FF] max-md:text-[15px]"
      />
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div className="min-w-0 flex-1">
          {links.length > 0 ? (
            <ul className="flex flex-wrap gap-2">
              {links.map((l) => (
                <li key={l.url} className="min-w-0 max-w-full">
                  <a
                    href={l.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    title={l.url}
                    className="group flex min-w-0 items-center gap-1.5 rounded-full bg-[#EEF2FF] py-1.5 pr-2.5 pl-2 text-xs font-medium text-[#1644EB] transition-colors hover:bg-[#E0E7FF]"
                  >
                    {l.esInstagram ? (
                      <Instagram className="w-3.5 h-3.5 shrink-0" />
                    ) : (
                      <Link2 className="w-3.5 h-3.5 shrink-0" />
                    )}
                    <span className="truncate">{l.etiqueta}</span>
                    <ExternalLink className="w-3 h-3 shrink-0 opacity-50 group-hover:opacity-100" />
                  </a>
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-xs text-neutral-400">
              Los links que pegues aparecen acá para abrirlos con un toque.
            </p>
          )}
        </div>
        {accion}
      </div>
    </>
  );
}
